import { render, staticRenderFns } from "./BasicInfoModal.vue?vue&type=template&id=c0125a74&scoped=true&"
import script from "./BasicInfoModal.vue?vue&type=script&lang=ts&"
export * from "./BasicInfoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0125a74",
  null
  
)

export default component.exports